import moment from "moment";
import {
    UPDATE_REBATES_MEMBER_EXPORT_QUARTER,
    UPDATE_REBATES_MEMBER_EXPORT_YEAR,
    UPDATE_REBATES_MEMBER_EXPORT_MODAL,
    UPDATE_SELECTED_REBATES_MEMBER_QUARTERS_LIST,
    UPDATE_SELECTED_REBATES_MEMBER_YEARS_LIST,
    EXPORT_MEMBER_ADMIN_REBATE_ERROR,
    exportMemberRebatesError,
    FetchError
} from "../../../constants";
import {saveAs} from "file-saver";
import {rebatesModalSpinner} from "../rebates";
import {exportMemberAdminList} from "../../../api/rebates/memberAdminRebates/EarnedRebates"
import serverApiV2Instance from "../../../services/serverApiV2Instance";

import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const memberAdminRebatesExportModal = (isMemberAdminExport) => async (dispatch, getState) => {
    dispatch({
        type: UPDATE_REBATES_MEMBER_EXPORT_MODAL,
        isMemberAdminExport
    });

    if (!isMemberAdminExport) return;

    const { memberAdminRebates } = getState();
    const memberId = memberAdminRebates?.selectedMember?.id;

    if (!memberId) return;

    try {
        const res = await serverApiV2Instance.get(`/members/${memberId}/earned-rebate-quarters`);
        const records = res?.data?.records ?? [];

        const quartersList = [];
        const yearsList = [];

        records.forEach((item) => {
            if (!quartersList.find((q) => q.value === item.quarter)) {
                quartersList.push({ label: `Q${item.quarter}`, value: item.quarter });
            }
            if (!yearsList.find((y) => y.value === item.year)) {
                yearsList.push({ label: item.year, value: item.year });
            }
        });

        dispatch({ type: UPDATE_SELECTED_REBATES_MEMBER_QUARTERS_LIST, memberQuartersList: quartersList });
        dispatch({ type: UPDATE_SELECTED_REBATES_MEMBER_YEARS_LIST, memberYearsList: yearsList });
    } catch (error) {
        toast.error(FetchError);
    }
}

export const handleMemberAdminExportQuarter = (exportQuarter) => async (dispatch) => {
    dispatch({
        type: UPDATE_REBATES_MEMBER_EXPORT_QUARTER,
        exportQuarter
    });
}

export const handleMemberAdminExportYear = (exportYear) => async (dispatch) => {
    dispatch({
        type: UPDATE_REBATES_MEMBER_EXPORT_YEAR,
        exportYear
    });
}

export const onExportMemberAdminRebates = () => async (dispatch, getState) => {
    const {memberAdminRebates} = getState();
    const {exportQuarter, exportYear, selectedMember} = memberAdminRebates;
    dispatch(rebatesModalSpinner(true))
    try {
        const response = await exportMemberAdminList({
            memberId: selectedMember.id,
            exportQuarter,
            exportYear
        })
        const date = new Date();
        const fileName = `Member_Admin_Rebates_${moment(date).format('DD_MMM_YYYY_hh:mm:ss_A')}.xls`;

        saveAs(response, fileName);
        dispatch(rebatesModalSpinner(false))
        dispatch(memberAdminRebatesExportModal(false))
    } catch (error) {
        dispatch(memberAdminRebatesExportModal(false))
        dispatch(rebatesModalSpinner(false))
        if (error === EXPORT_MEMBER_ADMIN_REBATE_ERROR) {
            toast.error(exportMemberRebatesError)
        }
    }
}